import React, { Component } from 'react';
import { TouchableOpacity, Text, Modal, View } from 'react-native';
import styles from './style';

interface Props {
    isVisible: boolean;
    title: string;
    content: any;
    cancelBtnText: string;
    okBtnText: string;
    onOk?(): void;
    onCancel?(): void;
    conStyle:any;
    cancelBtnOnRight: boolean; // 取消按钮是否在右侧,默认是false
    cancelBtnStyle?: any; // 取消按钮额外样式
    okBtnStyle?: any; // 确定按钮额外样式
}

class Confirm extends Component<Props> {
    // public onMaskTap = () => {};

    public render() {
        const { isVisible, onOk, onCancel, title, content, cancelBtnText, okBtnText,conStyle, cancelBtnOnRight, cancelBtnStyle, okBtnStyle } = this.props;
        return (
            <Modal
                visible={isVisible}
                transparent
                hardwareAccelerated
                animationType="fade"
                onRequestClose={() => onCancel?.()}
            >
                <TouchableOpacity activeOpacity={1} style={styles.confirmWrapper} onPress={() => onCancel?.()}>
                    <TouchableOpacity activeOpacity={1} style={[styles.confirm, conStyle]} onPress={() => { }}>
                        <View style={styles.confirmHead}>
                            <Text style={styles.confirmHeadTitle}>{title}</Text>
                        </View>
                        {Boolean(content) && (
                            <View style={styles.confirmContent}>
                                {
                                    typeof content == 'string'?(
                                        <Text style={styles.confirmContentText}>{content}</Text>
                                    ):(
                                        content
                                    )
                                }
                            </View>
                        )}
                        <View style={[styles.confirmFoot, {flexDirection: Boolean(cancelBtnOnRight)? 'row-reverse': 'row'}]}>
                            <TouchableOpacity
                                activeOpacity={1}
                                style={styles.confirmBtn}
                                onPress={() => onCancel?.()}
                            >
                                <Text style={[styles.confirmBtnText, cancelBtnStyle]}>{cancelBtnText}</Text>
                            </TouchableOpacity>
                            <View style={styles.confirmSticky} />
                            <TouchableOpacity
                                activeOpacity={1}
                                style={styles.confirmBtn}
                                onPress={() => onOk?.()}
                            >
                                <Text style={[styles.confirmBtnText, okBtnStyle]}>{okBtnText}</Text>
                            </TouchableOpacity>
                        </View>
                    </TouchableOpacity>
                </TouchableOpacity>
            </Modal>
        );
    }
}

export default Confirm;
